<template lang="pug">
#tabela-sancoes-restricoes-pf
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )

    el-collapse(v-model='activeCollapseItem')
        div(v-for='(item, index) in tiposSancoesRestricoes')
            el-collapse-item(:title='item.titulo', :name='index.toString()')
                template(slot='title')
                    | {{ item.titulo }}
                    i.mdi.mdi-minus-circle.ml-2(v-if='!item.temResultados')(
                        style='font-size: 20px; color: #686868'
                    )
                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.cnepCadastroNacionalDeEmpresasPunidas') && dados.cnep"
                )
                    div(v-for='(processo, index) in dados.cnep.processos')
                        el-divider(v-if='index !== 0')
                        BaseInfoBlock(
                            :titulos-info-block="[t('mensagens.preAnaliseCredito.sancoesRestricoes.dataInicialSancao'), t('mensagens.preAnaliseCredito.sancoesRestricoes.dataFinalSancao')]",
                            :valores-info-block='[mxFormatarData(processo.dataInicioSancao), mxFormatarData(processo.dataFinalSancao)]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.numeroProcesso'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.orgaoSancionador')]",
                            :valores-info-block='[processo.numeroProcesso, processo.orgaoSancionador]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.tipoSancao'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.ufOrgao')]",
                            :valores-info-block='[processo.tipoSancao, processo.ufOrgaoSancionador]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.valorMulta')]",
                            :valores-info-block='[formatValorBRL(processo.valorMulta)]'
                        )
                        div(v-if='index !== dados.cnep.processos.length - 1')
                            br
                            br
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.cnepCadastroNacionalDeEmpresasPunidas') && !dados.cnep",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.cnia') && dados.cnjCnia"
                )
                    div(v-for='(processo, index) in dados.cnjCnia.processos')
                        el-divider(v-if='index !== 0')
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.assunto'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.ufOrgao')]",
                            :valores-info-block='[processo.assuntosRelacionados, processo.cargoFuncao.uf]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.dataCadastramento'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.orgao')]",
                            :valores-info-block='[mxFormatarData(processo.dataCadastramento), mxFormatarData(processo.descricaoOrgao)]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.esfera'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.numeroDoProcesso')]",
                            :valores-info-block='[processo.esfera, processo.numeroProcesso]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.valorMulta'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.situacao')]",
                            :valores-info-block='[formatValorBRL(processo.pagamentoMulta.valor), processo.situacao]'
                        )
                        div(v-if='index !== dados.cnjCnia.processos.length - 1')
                            br
                            br
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.cnia') && !dados.cnjCnia",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.crsfn') && dados.empresaBcbAcordaos"
                )
                    div(
                        v-for='(acordao, index) in dados.empresaBcbAcordaos.acordaos'
                    )
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.numeroAcordao'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.numeroProcesso')]",
                            :valores-info-block='[acordao.numeroAcordaoCRSFN, acordao.numeroProcesso]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.numeroRecurso'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.parte')]",
                            :valores-info-block='[acordao.numeroRecurso, acordao.parte]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.tipo')]",
                            :valores-info-block='[acordao.recurso]'
                        )
                        div(
                            v-if='index !== dados.empresaBcbAcordaos.acordaos.length - 1'
                        )
                            br
                            br
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.crsfn') && !dados.empresaBcbAcordaos",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.ceis') && dados.empresaCeis"
                )
                    div(v-for='(sancao, index) in dados.empresaCeis.sancoes')
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.complementoDoOrgao'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.dataInformacao')]",
                            :valores-info-block='[sancao.complementoOrgao, mxFormatarData(sancao.dataInformacao)]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.fundamentacaoLegal'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.orgaoSancionador')]",
                            :valores-info-block='[sancao.fundamentacaoLegal, sancao.orgaoSancionador]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.origemInformacao'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.numeroDoProcesso')]",
                            :valores-info-block='[sancao.origemInformacao, sancao.processo]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.dataInicioDaSancao'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.dataFimDaSancao')]",
                            :valores-info-block='[sancao.periodoSancao.inicio, sancao.periodoSancao.final]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.tipoDeSancao'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.ufDoOrgao')]",
                            :valores-info-block='[sancao.tipoSancao, sancao.uf]'
                        )
                        div(v-if='index !== dados.empresaCeis.sancoes.length - 1')
                            br
                            br
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.ceis') && !dados.empresaCeis",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.bacen') && dados.bancoCentral"
                )
                    div(
                        v-for='(inabilitado, index) in dados.bancoCentral.inabilitados'
                    )
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.penalidade'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.prazoEmAnos')]",
                            :valores-info-block='[inabilitado.penalidade, inabilitado.prazoAno]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.dataPrazoFinalPenalidade'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.dataPublicacao')]",
                            :valores-info-block='[mxFormatarData(inabilitado.dataPrazoFinalPenalidade), mxFormatarData(inabilitado.dataPublicacao)]'
                        )
                        div(
                            v-if='index !== dados.bancoCentral.inabilitados.length - 1'
                        )
                            br
                            br
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.bacen') && !dados.bancoCentral",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.cnjMandado') && dados.mandadoPrisao"
                )
                    div(v-for='(mandado, index) in dados.mandadoPrisao.mandados')
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.possuiMandadoDePrisao'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.numeroDoMandado')]",
                            :valores-info-block="[dados.mandadoPrisao.possuiMandado ? $t('mensagens.comuns.sim') : $t('mensagens.comuns.nao'), mandado.numeroMandado]"
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.dataDoMandado'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.dataDeValidade')]",
                            :valores-info-block='[mxFormatarData(mandado.dataMandado), mxFormatarData(mandado.dataValidade)]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.magistradoResponsavelPeloMandado'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.situacaoDoMandado')]",
                            :valores-info-block='[mandado.magistrado, mandado.situacaoMandado]'
                        )
                        div(v-if='index !== dados.mandadoPrisao.mandados.length - 1')
                            br
                            br
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.cnjMandado') && !dados.mandadoPrisao",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.mteTrabalhoEscravo') && dados.mteTrabalhoEscravo"
                )
                    div(
                        v-for='(estab, index) in dados.mteTrabalhoEscravo.estabelecimentos'
                    )
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.anoDaAcaoFiscal'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.dataDecisaoAdministrativa')]",
                            :valores-info-block='[estab.anoAcaoFiscal, mxFormatarData(estab.dataDecisaoProcedencia)]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.logradouro'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.complemento')]",
                            :valores-info-block='[estab.estabelecimento.logradouro, estab.estabelecimento.complemento]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.municipio'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.uf')]",
                            :valores-info-block='[estab.estabelecimento.municipio, estab.estabelecimento.uf]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.trabalhadoresEnvolvidos')]",
                            :valores-info-block='[estab.numeroTrabalhadoresEnvolvidos]'
                        )
                        div(v-if='index !== dados.mteTrabalhoEscravo.estabelecimentos.length - 1')
                            br
                            br
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.mteTrabalhoEscravo') && !dados.mteTrabalhoEscravo",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.ceafCadastro') && dados.punicao"
                )
                    div(v-for='(punicaoItem, index) in dados.punicao.punicoes')
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.cargoEfetivo'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.dataDePortariaDaPunicao')]",
                            :valores-info-block='[punicaoItem.cargoEfetivo, mxFormatarData(punicaoItem.dataPortariaPunicao)]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.descricaoDaPunicao'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.numeroDoProcesso')]",
                            :valores-info-block='[punicaoItem.descricaoPunicao, punicaoItem.numeroProcesso]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.orgaoDeLotacao'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.tipoDePunicao')]",
                            :valores-info-block='[punicaoItem.orgaoLotacao, punicaoItem.tipoPunicao]'
                        )
                        el-divider
                        BaseInfoBlock(
                            :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.ufDoOrgao')]",
                            :valores-info-block='[punicaoItem.ufLotacao]'
                        )
                        div(v-if='index !== dados.punicao.punicoes.length - 1')
                            br
                            br
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.ceafCadastro') && !dados.punicao",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.certidaoAntecedentesCriminais') && dados.historicoCriminal"
                )
                    BaseInfoBlock(
                        :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.dataDaConsulta'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.numeroDoProtocolo')]",
                        :valores-info-block='[mxFormatarData(dados.historicoCriminal.dataConsulta), dados.historicoCriminal.protocolo]'
                    )
                    el-divider
                    BaseInfoBlock(
                        :titulos-info-block="[$t('mensagens.preAnaliseCredito.sancoesRestricoes.situacao'), $t('mensagens.preAnaliseCredito.sancoesRestricoes.status')]",
                        :valores-info-block='[dados.historicoCriminal.situacao, dados.historicoCriminal.status]'
                    )
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.certidaoAntecedentesCriminais') && !dados.historicoCriminal",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.tcuListaContasIrregulares') && dados.tcuContasIrregulares"
                )
                    el-table(
                        :data='dados.tcuContasIrregulares.processos',
                        height='100%',
                        style='width: 100%; max-height: 300px; overflow: auto',
                        stripe
                    )
                        el-table-column(
                            :label="$t('mensagens.preAnaliseCredito.sancoesRestricoes.municipio')",
                            prop='nomeMunicipio',
                            align='left',
                            min-width='250px'
                        )
                        el-table-column(
                            :label="$t('mensagens.preAnaliseCredito.sancoesRestricoes.uf')",
                            prop='uf',
                            align='left',
                            min-width='170px'
                        )
                        el-table-column(
                            :label="$t('mensagens.preAnaliseCredito.sancoesRestricoes.processo')",
                            prop='processo',
                            align='left',
                            min-width='160px'
                        )
                        el-table-column(
                            :label="$t('mensagens.preAnaliseCredito.sancoesRestricoes.transitoEmJulgado')",
                            align='left',
                            prop='transitoEmJulgado'
                            min-width='90'
                        )
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.tcuListaContasIrregulares') && !dados.tcuContasIrregulares",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )
                .tabela-rodape-somatorio(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.tcuListaContasIrregulares') && dados.tcuContasIrregulares"
                )
                    p {{ dados.tcuContasIrregulares.processos.length }} {{ t('mensagens.preAnaliseCredito.sancoesRestricoes.processosMinusculo') }}
                        
                div(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.tcuListaLicitantesInidoneos') && dados.tcuInidonios"
                )
                    el-table(
                        :data='dados.tcuInidonios.processos',
                        height='100%',
                        style='width: 100%; max-height: 300px; overflow: auto',
                        stripe
                    )
                        el-table-column(
                            :label="$t('mensagens.preAnaliseCredito.sancoesRestricoes.uf')",
                            prop='uf',
                            align='left',
                            min-width='80px'
                        )
                        el-table-column(
                            :label="$t('mensagens.preAnaliseCredito.sancoesRestricoes.processo')",
                            prop='processo',
                            align='left',
                            min-width='100px'
                        )
                        el-table-column(
                            :label="$t('mensagens.preAnaliseCredito.sancoesRestricoes.deliberacao')",
                            prop='deliberacao',
                            align='left',
                            :formatter='isEmpty',
                            min-width='90px'
                        )
                        el-table-column(
                            :label="$t('mensagens.preAnaliseCredito.sancoesRestricoes.transitoEmJulgado')",
                            align='left',
                            prop='transitoEmJulgado'
                            :formatter='isEmpty',
                            min-width='100'
                        )
                        el-table-column(
                            :label="$t('mensagens.preAnaliseCredito.sancoesRestricoes.dataFinal')",
                            align='left',
                            prop='dataFinal'
                            min-width='90'
                        )
                        el-table-column(
                            :label="$t('mensagens.preAnaliseCredito.sancoesRestricoes.dataDoAcordao')",
                            align='left',
                            prop='dataAcordao'
                            min-width='90'
                        )
                el-alert(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.tcuListaLicitantesInidoneos') && !dados.tcuInidonios",
                    :title="`${$t('mensagens.preAnaliseCredito.naoHaRegistroPara')} ${item.titulo}`",
                    type='warning',
                    :closable='false'
                )
                .tabela-rodape-somatorio(
                    v-if="item.titulo === $t('mensagens.preAnaliseCredito.sancoesRestricoes.tcuListaLicitantesInidoneos') && dados.tcuInidonios"
                )
                    p {{ dados.tcuInidonios.processos.length }} {{ $t('mensagens.preAnaliseCredito.sancoesRestricoes.processosMinusculo') }}
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/components/preAnaliseCredito/BaseTableHeader';
import BaseInfoBlock from '@/components/preAnaliseCredito/BaseInfoBlock';

export default {
    name: 'TabelaSancoesRestricoesPf',

    components: {
        BaseTableHeader,
        BaseInfoBlock
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-cloud-search-outline'
        },
        dados: {
            type: Object,
            required: true,
            default: () => {}
        }
    },

    data() {
        return {
            activeCollapseItem: ['0']
        };
    },
    computed: {
        tiposSancoesRestricoes() {
            return (
                this.mxCheckTiposSancoesRestricoesPFResults(this.dados) || []
            );
        }
    },

    methods: {
        formatarCep(row, column, cep, index) {
            return formatters.formatarCEP(cep);
        },
        formatValorAvaliadoTableColumn(row, column, valorAvaliado, index) {
            return 'R$ ' + formatters.maxFormatNumber(valorAvaliado, 2);
        },
        isEmpty(row, column, data, index) {
            return formatters.isEmpty(data);
        },
        formatValorBRL(valor) {
            return 'R$ ' + formatters.formatNumber(valor, 2);
        }
    }
};
</script>

<style lang="scss">
#tabela-sancoes-restricoes-pf {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .el-collapse-item {
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px;
        margin-bottom: 12px;
    }

    .el-collapse-item__header {
        position: relative;
        border-radius: 5px;
        height: 35px !important;
        padding: 22px 0px 22px 40px;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
    }

    .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
        top: 31%;
        font-size: 16px;
        font-weight: 600;
    }

    .el-collapse-item__wrap {
        padding: 12px;
        border-bottom: none !important;
    }

    .el-table {
        border-radius: 5px;

        .cell {
            word-break: break-word !important;
        }

        .el-table__body-wrapper {
            overflow-x: auto !important;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
            max-height: 100px;
            overflow-y: auto;
        }

        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 14px;
            font-weight: 500;
            line-height: 16.75px;

            th {
                max-width: 132px;
            }
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }
    }

    .table-patrimonio {
        height: 100%;
        width: 100%;
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-left: 21px;
        padding-top: 17px;
    }

    .el-collapse-item__content {
        padding-bottom: 5px !important;
    }
}
</style>
